/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */

AddModel({
	Name: "StripedSkirt",
	Folder: "Skirts",
	Parent: "StripedSkirt",
	TopLevel: true,
	Categories: ["Skirts"],
	AddPoseConditional: {
		EncaseTorsoLower: ["Skirt"]
	},
	Layers: ToLayerMap([
		{ Name: "StripedSkirt", Layer: "Skirt", Pri: 16,
			//swaplayerpose: {Kneel: "SkirtOverLower", KneelClosed: "SkirtOverLower"},
			Poses: ToMap([...LEGPOSES]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			//HideWhenOverridden: true,
			MorphPoses: {Hogtie: "Closed", Closed: "", Kneel: "Kneel", KneelClosed: "Kneel"},
			AppendPose: ToMapDupe(["CrotchStrap"]),
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			InheritColor: "Skirt",
			Invariant: true,
			HidePoses: {"SkimpyLower": true},
		},
		{ Name: "StripedSkirtUnder", Layer: "Skirt", Pri: 16.1,
			//swaplayerpose: {Kneel: "SkirtOverLower", KneelClosed: "SkirtOverLower"},
			TieToLayer: "StripedSkirt",
			Poses: ToMap([...LEGPOSES]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			//HideWhenOverridden: true,
			MorphPoses: {Hogtie: "Closed", Closed: "", Kneel: "Kneel", KneelClosed: "Kneel"},
			AppendPose: ToMapDupe(["CrotchStrap"]),
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			InheritColor: "Underskirt",
			Invariant: true,
		},
		{ Name: "StripedSkirtOver", Layer: "SkirtOverKneel", Pri: 16,
			Poses: ToMap([...KNEELPOSES]),
			TieToLayer: "StripedSkirt",
			NoOverride: true,
			AppendPose: ToMapDupe(["CrotchStrap"]),
			InheritColor: "Skirt",
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			//Invariant: true,
		},
		{ Name: "StripedSkirtUnderOver", Layer: "SkirtOverKneel", Pri: 16.1,
			Poses: ToMap([...KNEELPOSES]),
			TieToLayer: "StripedSkirtOver",
			NoOverride: true,
			AppendPose: ToMapDupe(["CrotchStrap"]),
			InheritColor: "Underskirt",
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			//Invariant: true,
		},
	])
});


AddModel({
	Name: "ApronSkirt",
	Folder: "Skirts",
	Parent: "MaidSkirt",
	TopLevel: true,
	Categories: ["Skirts"],
	AddPoseConditional: {
		EncaseTorsoLower: ["Skirt"]
	},
	Layers: ToLayerMap([
		{ Name: "MaidSkirt", Layer: "Skirt", Pri: 17,
			//swaplayerpose: {Kneel: "SkirtOverLower", KneelClosed: "SkirtOverLower"},
			Poses: ToMap([...LEGPOSES]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			//HideWhenOverridden: true,
			MorphPoses: {Hogtie: "Closed", Closed: "", Kneel: "Kneel", KneelClosed: "Kneel"},
			AppendPose: ToMapDupe(["CrotchStrap"]),
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			InheritColor: "Skirt",
			Invariant: true,
			HidePoses: {"SkimpyLower": true},
		},
		{ Name: "ApronSkirt", Layer: "Skirt", Pri: 17.1,
			//swaplayerpose: {Kneel: "SkirtOverLower", KneelClosed: "SkirtOverLower"},
			TieToLayer: "MaidSkirt",
			Poses: ToMap([...LEGPOSES]),
			GlobalDefaultOverride: ToMap(["Hogtie"]),
			//HideWhenOverridden: true,
			MorphPoses: {Hogtie: "Closed", Closed: "", Kneel: "Kneel", KneelClosed: "Kneel"},
			AppendPose: ToMapDupe(["CrotchStrap"]),
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			InheritColor: "Apron",
			Invariant: true,
		},
		{ Name: "MaidSkirtOver", Layer: "SkirtOverKneel", Pri: 17,
			Poses: ToMap([...KNEELPOSES]),
			TieToLayer: "MaidSkirt",
			NoOverride: true,
			AppendPose: ToMapDupe(["CrotchStrap"]),
			InheritColor: "Skirt",
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			//Invariant: true,
		},
		{ Name: "ApronSkirtOver", Layer: "SkirtOverKneel", Pri: 17.1,
			Poses: ToMap([...KNEELPOSES]),
			TieToLayer: "MaidSkirtOver",
			NoOverride: true,
			AppendPose: ToMapDupe(["CrotchStrap"]),
			InheritColor: "Apron",
			HidePrefixPose: ["Encase"],	HidePrefixPoseSuffix: ["TorsoLower"],
			//Invariant: true,
		},
	])
});